import { jsxs as n, jsx as r, Fragment as y } from "react/jsx-runtime";
import { twMerge as a } from "tailwind-merge";
import { Tooltip as C } from "../../tooltip/index.mjs";
import { FieldLabel as v } from "../../form/field-label.mjs";
import { FieldErrorAndDescription as L } from "../../form/field-error-and-description.mjs";
const j = ({
  options: t,
  selected: l,
  onChange: s,
  disabled: i,
  error: c,
  label: d,
  required: m,
  className: o,
  labelClassName: p,
  optionsWrapperClassName: h,
  optionWrapperClassName: f,
  selectedOptionWrapperClassName: x,
  optionClassName: u,
  inputClassName: g,
  contentClassName: b,
  tooltipClassName: N
}) => /* @__PURE__ */ n("div", { className: a("flex flex-col gap-1", o), children: [
  /* @__PURE__ */ r(v, { label: d, labelClassName: p, required: m }),
  /* @__PURE__ */ r("ul", { className: a("flex items-center gap-5", h), children: t ? t.map((e) => /* @__PURE__ */ r(
    C,
    {
      label: e.tooltipLabel ?? "",
      disabled: !e.showTooltip,
      className: N,
      children: /* @__PURE__ */ n(
        "li",
        {
          className: a(
            f,
            e.id === l && x
          ),
          children: [
            /* @__PURE__ */ n(
              "label",
              {
                className: a(
                  "r relative flex w-fit items-center gap-2",
                  !i && "cursor-pointer"
                ),
                children: [
                  /* @__PURE__ */ r(
                    "input",
                    {
                      className: a(
                        "border-2 outline-hidden",
                        i ? "border-fill-primary/70" : "border-fill-primary",
                        "h-[20px] w-[20px] rounded-full",
                        e.id === l ? "bg-background-secondary" : "bg-transparent",
                        "main-transition-colors focus-ring shrink-0 appearance-none",
                        g
                      ),
                      disabled: i || e.disabled,
                      checked: e.id === l,
                      value: e.caption,
                      onChange: () => s(e.id),
                      type: "radio"
                    }
                  ),
                  /* @__PURE__ */ r(
                    "svg",
                    {
                      width: 20,
                      height: 20,
                      className: a(
                        "main-transition-colors absolute",
                        e.id === l ? "fill-green" : "fill-transparent",
                        i && "opacity-70"
                      ),
                      children: /* @__PURE__ */ r(
                        "path",
                        {
                          fillRule: "evenodd",
                          clipRule: "evenodd",
                          d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ n("div", { className: "flex items-center gap-3", children: [
                    e.caption && /* @__PURE__ */ r(
                      "span",
                      {
                        className: a(
                          "main-transition-colors",
                          e.id === l ? "text-text-primary" : "text-text-primary/50",
                          i && "opacity-70",
                          u,
                          "text-left"
                        ),
                        children: e.caption
                      }
                    ),
                    e.additionalInfo
                  ] })
                ]
              }
            ),
            e.content && e.id === l && /* @__PURE__ */ r("div", { className: a("pt-2", b), children: e.content })
          ]
        }
      )
    },
    e.id
  )) : /* @__PURE__ */ n(y, { children: [
    /* @__PURE__ */ r(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ r(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ r(L, { error: c })
] });
export {
  j as RadioGroup
};
